<template>
  <el-dialog
      append-to-body
      :show-close="false"
      :visible.sync="dialogFormVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false">
    <div slot="title" class="header">
<!--      @/assets/img/home/buyItem.png-->
      <img :src="spu.img" alt="" @error="onImageError">
      <div class="info">
        <div class="price">
          <!-- 现价-->
          <div class="price-current">
            <span class="currency">$</span>{{ filterObj(skuList,'id',form1.skuid).price }}
          </div>
          <!-- 原价:仅在折扣码使用成功后显示-->
          <div v-if="discountCodeFlag && filterObj(skuList,'id',form1.skuid).originalprice" class="price-original">
            <span class="currency">$</span>
            <span class="amount">{{ filterObj(skuList,'id',form1.skuid).originalprice }}</span>
          </div>
        </div>
        <!-- 平均每月  price/（skumonth+giftstimes）-->
        <div class="average">$ {{ filterObj(skuList,'id',form1.skuid).averageprice }} / {{$t('home.month')}}</div>
        <!-- 赠送 -->
        <div class="average"  v-if="filterObj(skuList,'id',form1.skuid).giftstimes > 0">
          <span>
            {{ $t("home.gift") }} {{ filterObj(skuList,'id',form1.skuid).giftstimes }} Months</span>
        </div>
        <!-- {0}位-->
        <div class="desc">{{$t('home.position',{0:form1.num})}}</div>
      </div>
    </div>
    <div class="content">
      <!-- 购买月份-->
      <div class="mon mb-2" v-if="monthCount>0">
        <div class="content-title">{{$t('home.selectamonth')}}</div>
        <div class="month">
          <div v-for="(mItem,mIndex) in spu.skus"
               :key="mIndex"
               v-if="mItem.ext1=='1'"
               :class="[{'active':form1.skuid===mItem.id&&!mItem.soldOutFlag},'item']"
               @click="selectMonth(mItem)">
            {{ mItem.skuname }}
            <span class="sold-out" v-show="mItem.soldOutFlag">售罄</span>
          </div>
        </div>
      </div>

      <!-- 选择类型  按type需区分多种情况显示-->
      <div class="type mb-8">
        <!-- 选择类型-->
        <div class="content-title">{{$t('home.screen')}}</div>
        <template v-if="spu.type == '3'">
          <div :class="[{'active':form1.num==1},'item']" @click="changeType(1)">
            {{ $t("home.1screen") }}
          </div>
          <div :class="[{'active':form1.num===2},'item']" @click="changeType(2)">
            {{ spu.maxnum }}{{ $t("home.maxnum") }}
          </div>
        </template>
        <template v-if="spu.type == '1'">
          <div :class="[{'active':form1.num==1},'item']" @click="changeType(1)">
            {{ $t("home.1screen") }}
          </div>
        </template>
        <template v-if="spu.type == '2'">
          <div :class="[{'active':form1.num==2},'item']" @click="changeType(2)">
            {{ spu.maxnum }}{{ $t("home.maxnum") }}
          </div>
        </template>
      </div>


      <!-- 有促销码或优惠券吗？-->
      <div class="couponN" v-show="!chooseCoupon" @click="changeChooseCoupon">有促销码或优惠券吗？</div>
      <div class="couponY" v-show="chooseCoupon">
        <div class="couponY-top">
          <!-- 选择折扣（选择一项）-->
          <div class="content-title mb-0">{{$t('home.selectdiscount')}}</div>
<!--          <i class="el-icon-close" @click="resetCoupon"></i>-->
        </div>
        <el-form :model="form1" ref="dataFormRef">
<!--          <el-form-item class="couponY-coupon mb-4">-->
<!--            <div class="desc" v-if="!form1.coupon">2可用，最多优惠$ 1.60</div>-->
<!--            <el-select-->
<!--                v-model="form1.coupon"-->
<!--                placeholder="选择优惠劵">-->
<!--              <el-option-->
<!--                  v-for="item in couponList"-->
<!--                  :key="item.value"-->
<!--                  :label="item.label"-->
<!--                  :value="item.value">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
          <!-- 折扣码-->
          <el-form-item class="couponY-code">
            <el-input v-model.trim="form1.discountcode" @input="changeDiscountCode" :placeholder="$t('home.discountcode')"/>
            <!-- 使用-->
            <el-button size="small" type="primary" :disabled="!form1.discountcode" @click="useDiscountcode">{{ $t("home.use") }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- 取消-->
      <el-button @click="closeDialog">{{$t('friends.cancel')}}</el-button>
      <!-- 前往付款-->
      <el-button type="primary" @click="goPay">{{$t('home.buynow')}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  filterObj,
  formatObj,
  isEmpty,
  getUserInfo,
  MessageError,
  startLoading
} from "@/util/util";
import {
  calprice
} from "@/request/requests";

export default {
  name: "toBuy",
  props:{
    form1Obj:{
      type:Object,
      default:()=>{
        return {
          goodsid: "",
          skuid: "",
          num: "",
          buytype: "",
          paycode: "",
          discountcode: "",
        }
      }
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      defaultMonIndex:'',
      chooseCoupon:true,
      spu:{},
      userinfo:"",
      form1:{
        goodsid: "",
        skuid: "",
        num: "",
        buytype: "",
        paycode: "",
        discountcode: "",
      },
      couponList:[
        {
          value:'a',
          label:'7% OFF($1.60)'
        },
        {
          value:'b',
          label:'7% OFF($1.60)'
        }
      ],
      //是否已成功使用折扣码
      discountCodeFlag:false,
      price:0,
      screenWidth:null,
      spuTemp:{},
      skuList:[],
      monthShow:true,
      monthCount:0


    }
  },
  watch:{
    form1Obj:{
      handler(newVal){
        if(newVal){
          this.form1 = newVal;
        }
      },
      immediate:true,
      deep:true
    }
  },
  methods: {
    filterObj,
    init(spu) {
      this.spu = formatObj(spu);
      //存一份原始数据
      this.spuTemp = formatObj(spu);
      this.monthCount = 0;
      if(!isEmpty(this.spu.skus)){
        this.skuList = this.spu.skus;
        this.skuList.forEach(item =>{
          //原价
          this.$set(item,'originalprice',"");
          //平均每月价格 price/skumonth+giftstimes
          this.$set(item,'averageprice',(item.price/(item.skumonth+item.giftstimes)).toFixed(2));
          //月份区域是否显示
          if(item.ext1=='1'){
            this.monthCount++;
          }
        })
        console.log(this.skuList)
      }
      this.dialogFormVisible = true;
    },
    changeType(num){
      this.$set(this.form1,'num',num);
    },
    changeDiscountCode(val){
      if(isEmpty(val)){
        //折扣码未使用
        this.discountCodeFlag = false;
        //恢复初始价格
        this.skuList = formatObj(this.spuTemp.skus);
        this.skuList.forEach(item =>{
          //现价
          //this.$set(item,'price',(this.form1.num * item.price).toFixed(2));
          //原价
          this.$set(item,'originalprice',"");
          //平均每月价格 price/skumonth+giftstimes
          this.$set(item,'averageprice',(item.price/(item.skumonth+item.giftstimes)).toFixed(2));
        })
      }
    },
    checkIsLogin(){
      if (!this.userinfo){
        this.dialogFormVisible = false;
        if (this.screenWidth > 576.98) {
          this.$router.push({name:'login'});
        } else {
          this.$router.push({name:'phonelogin'});
        }
        return false;
      }else{
        return true;
      }
    },
    async useDiscountcode(){
      let code = this.form1.discountcode;
      if ("" == code || null == code) {
        // MessageError("Discount code cannot be empty!")
        MessageError(this.$t("home.discountcodenotempty"));
        return;
      }

      if(!this.checkIsLogin()){
        return
      }

      let data = {
        goodsid: this.form1.goodsid,
        skuid: this.form1.skuid,
        num: this.form1.num * 1,
        discountcode: this.form1.discountcode,
        userid: this.userinfo.id,
      }
      let loading = startLoading();
      let res = await calprice(data);
      if (res.status == "200") {
        //使用折扣码已生效
        if (!isEmpty(res.data)
            && 0 != res.data
            && parseFloat(res.data) < parseFloat(this.filterObj(this.skuList,'id',this.form1.skuid).price)) {
          this.skuList.some(item =>{
            if(item.id === this.form1.skuid){
              //原价
              this.$set(item,'originalprice',item.price);
              //现价
              this.$set(item,'price',res.data);
              //平均每月价格 price/skumonth+giftstimes
              this.$set(item,'averageprice',(item.price/(item.skumonth+item.giftstimes)).toFixed(2));
              return true
            }
          })
          this.discountCodeFlag = true;
        }
        loading.close();
      } else {
        MessageError(res.msg);
        loading.close();
      }
    },
    onImageError(){
      event.target.src = '';
    },
    selectMonth(item){
      this.$set(this.form1,'skuid',item.id);
      //已成功的使用了折扣码
      if(this.discountCodeFlag){
        //重新计算已选中的折扣码计算后的 现价 price  原价 originalprice  平均每月价格 averageprice
        this.useDiscountcode();
      }
    },
    resetCoupon(){
      this.changeChooseCoupon();
      this.resetForm();
    },
    changeChooseCoupon(){
      this.chooseCoupon = !this.chooseCoupon;
    },
    resetForm(){
      Object.assign(this.$data.form1, this.$options.data().form1) ;
    },
    closeDialog(){
      this.discountCodeFlag = false;
      this.skuList = [];
      this.spuTemp = {};
      this.dialogFormVisible = false;
    },
    goPay(){
      if(!this.checkIsLogin()){
        return
      }
      let skuObj = this.filterObj(this.skuList,'id',this.form1.skuid);
      let priceDataForm = {
        //现价
        price: skuObj.price,
        skuname: skuObj.skuname,
        giftstimes: skuObj.giftstimes,
        //原价
        originalprice: skuObj.originalprice,
        //平均每月价格
        averageprice: skuObj.averageprice
      }
      this.$emit('goPay',formatObj(priceDataForm),formatObj(this.form1),this.discountCodeFlag);
    },
    calcWidth() {
      this.screenWidth = window.screen.width;
      this.$forceUpdate();
    },

  },
  mounted(){
    let userInfo = getUserInfo();
    if (userInfo) {
      this.userinfo = JSON.parse(userInfo);
    }
    this.$nextTick(() => {
      this.calcWidth();
      window.addEventListener("resize", this.calcWidth);
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcWidth);
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  max-width:calc(100% - 40px) !important;
  width:700px!important;
  .header {
    display: flex;
  }

  &__header {
    border-bottom: 1px solid #f5f2f2;
    padding: 20px;

    img {
      width: 120px;
      object-fit: contain;
      background-color: #84F0AA;
      border-radius: 32px;
    }

    .info {
      flex: 1;
      font-size: 24px;
      margin-left: 24px;
    }

    .price {
      display: flex;
      align-items: center;

      &-current {
        color: #ef534f;
        font-size: 32px;
        font-weight: 700;

        .currency {
          font-size: 24px;
        }
      }

      &-original {
        color: #a3a2a2;
        font-size: 24px;
        font-weight: 500;
        margin-left: 8px;

        .currency {
          font-size: 16px;
        }

        .amount {
          text-decoration: line-through;
        }
      }

    }

    .average {
      background: rgba(239, 83, 79, .15);
      border-radius: 26px;
      color: #ef534f;
      display: inline-block;
      font-size: 14px;
      font-weight: 500;
      padding: 0 8px;
      margin-bottom:20px;
    }

    .desc{
      color: #a3a2a2;
      font-size: 14px;
    }
  }

  &__body{
    border: 1px solid #f5f2f2
  }
  &__footer{
    padding:20px!important;
  }

  .content{
    &-title{
      font-size: 14px;
      font-weight: 700;
      color:#000;
      margin-bottom:10px;
    }

    .month{
      display:flex;
      align-items: center;
      width:100%;
      flex-wrap: wrap;
    }
    .item{
      position: relative;
      border-radius: 8px;
      background-color: #fbf8f8;
      padding: 12px 16px;
      cursor: pointer;
      margin-bottom:15px;
      &:not(:last-child){
        margin-right:16px;
      }
    }
    .active{
      color: #ef534f;
      border: 2px solid #ef534f;
    }
    .sold-out{
      background: #f0eded;
      border-radius: 0 8px;
      color: #a3a2a2;
      display: inline;
      font-size: 10px;
      padding: 0 4px;
      position: absolute;
      right: -2px;
      top: -2px;
    }


    .couponN{
      text-decoration: underline;
      font-weight: bold;
      color:#000;
      cursor: pointer;
    }
    .couponY{
      &-top{
        cursor: pointer;
        margin-bottom:20px;
        display:flex;
        align-items: center;
        justify-content: space-between;
      }
      .el-icon-close{
        font-size: 20px;
        color: rgb(187, 187, 187);
        cursor: pointer;
      }


      &-coupon{
        position:relative;
        .desc{
          position: absolute;
          top: 50%;
          right: 39px;
          transform: translateY(-50%);
          z-index: 99;
        }
      }

      &-code{
        margin-bottom:0;
        .el-form-item__content{
          display:flex;
          align-items: center;
        }
        .el-input{
          flex:1;
        }
        .el-button{
          width:12%;
          margin-left:10px;
          padding:15px 8px;
          white-space: pre-line;
        }
      }
    }



  }

}
.dialog-footer{
  .el-button{
    font-size:14px;
    padding: 20px 40px !important;
    border-radius: 34px !important;
    width:auto;
    @media(max-width:575.98px){
      padding:10px 40px!important;
    }
  }
}
</style>
